import _get from 'lodash/get';

export const hasLanguageSpecificResources = (resourceLanguages, allLanguages) =>
  resourceLanguages.some(lang =>
    allLanguages.includes(_get(lang, 'fields.title')),
  );
